import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { CrudService } from '../index';
import { RoleService } from '../role.service';
import { EventLog } from '../../dto/event-log';

@Injectable()
export class EventLogService {
  readonly apiPath = 'event-logs/';
  constructor(
    private http: HttpClient,
    private roleService: RoleService,  
  ) { }
/*
  [ HttpGet( "{target}/{id}" ) ]
  public async Task<IActionResult> Get( LogTarget target, long id ) {
    return Json( await _eventLogService.GetLogs( target, id ) );
  }
*/
  get(target: number, id: any ) {
    return this.http.get( [ this.apiPath + target, id ].join( '/' ) ) as Observable<Array<EventLog>>;
  }
}
